import { render, staticRenderFns } from "./UnitSelect.vue?vue&type=template&id=563008fc&scoped=true&"
import script from "./UnitSelect.vue?vue&type=script&lang=js&"
export * from "./UnitSelect.vue?vue&type=script&lang=js&"
import style0 from "./UnitSelect.vue?vue&type=style&index=0&id=563008fc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563008fc",
  null
  
)

export default component.exports